import { render, staticRenderFns } from "./NewQuotation.vue?vue&type=template&id=dd20e450&scoped=true&"
import script from "./NewQuotation.vue?vue&type=script&lang=js&"
export * from "./NewQuotation.vue?vue&type=script&lang=js&"
import style0 from "./NewQuotation.vue?vue&type=style&index=0&id=dd20e450&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd20e450",
  null
  
)

export default component.exports